import { render, staticRenderFns } from "./FormPlanInfo.vue?vue&type=template&id=2a278bac&scoped=true"
import script from "./FormPlanInfo.vue?vue&type=script&lang=js"
export * from "./FormPlanInfo.vue?vue&type=script&lang=js"
import style0 from "./FormPlanInfo.vue?vue&type=style&index=0&id=2a278bac&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a278bac",
  null
  
)

export default component.exports